var map = {
	"./chiadambram.webp": 3155,
	"./gomadurai.webp": 70325,
	"./kalaivani.webp": 98142,
	"./kannan.webp": 12727,
	"./mothil.webp": 64785,
	"./mugaishudeen.webp": 95885,
	"./nesakumar.webp": 27643,
	"./periasamymanikandan.webp": 86049,
	"./ravi.webp": 37052,
	"./sangeetha.webp": 35936,
	"./sathishram.webp": 65304,
	"./yuvaraj.webp": 6724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95090;